import { render, staticRenderFns } from "./DefaultWorkflowQueue.vue?vue&type=template&id=d01b78f0&scoped=true&"
import script from "./DefaultWorkflowQueue.vue?vue&type=script&lang=ts&"
export * from "./DefaultWorkflowQueue.vue?vue&type=script&lang=ts&"
import style0 from "./DefaultWorkflowQueue.vue?vue&type=style&index=0&id=d01b78f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01b78f0",
  null
  
)

export default component.exports